import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const PlaySolidIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('PlaySolidIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      fillRule="evenodd"
      d="M3.5 3.86c0-.913 1-1.472 1.778-.994l6.728 4.14c.74.456.74 1.532 0 1.988l-6.728 4.14A1.167 1.167 0 0 1 3.5 12.14z"
      clipRule="evenodd"
    />
  </svg>
);
PlaySolidIcon.id = 'PlaySolidIcon';
PlaySolidIcon.displayName = 'PlaySolidIcon';
export default PlaySolidIcon;
